import createIcon from '../../createIcon';

/**
 * @component @name TableBar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNy41QzIyIDUuNTcgMTcuNTIgNCAxMiA0QzYuNDggNCAyIDUuNTcgMiA3LjVDMiA5LjMxIDUuOTUgMTAuODEgMTEgMTAuOThWMTVIOS4zNUM4LjUzIDE1IDcuOCAxNS41IDcuNDkgMTYuMjZMNiAyMEg4TDkuMiAxN0gxNC44TDE2IDIwSDE4TDE2LjUgMTYuMjZDMTYuMiAxNS41IDE1LjQ2IDE1IDE0LjY1IDE1SDEzVjEwLjk4QzE4LjA1IDEwLjgxIDIyIDkuMzEgMjIgNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TableBar = createIcon('TableBar', [
  [
    'path',
    {
      d: 'M22 7.5C22 5.57 17.52 4 12 4C6.48 4 2 5.57 2 7.5C2 9.31 5.95 10.81 11 10.98V15H9.35C8.53 15 7.8 15.5 7.49 16.26L6 20H8L9.2 17H14.8L16 20H18L16.5 16.26C16.2 15.5 15.46 15 14.65 15H13V10.98C18.05 10.81 22 9.31 22 7.5Z',
      key: '1broto',
    },
  ],
]);

export default TableBar;
